import { BASE_URL } from "@/api/system/role"
import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"

import { ROLE_CODE } from "@/utils/pattern"

/**
 * 绘制新增表单
 */
 export function renderAddForm(el: Element) {
  const addForm = new FormDialog(
    el, 
    { 
      items: items, 
      elFormProps: { rules: rules }, 
      saveUrl: BASE_URL 
    },
    '新增'
  )

  return addForm
}

const items = [
  [
    createFormItem('角色名称', 'roleName', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' })
  ],
  [
    createFormItem('角色代码', 'roleCode', FORM_ITEM.INPUT, { clearable: true, maxlength: '20', showPassword: true })
  ],
  [
    createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'ROLE_STATUS', default: true, }),
    null
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]

const rules = {
  roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
  roleCode: [{ required: true, message: '请输入角色代码', trigger: 'blur' },
    { pattern: ROLE_CODE, message: '角色编码只能包含字母、数字、下划线', trigger: 'blur' }],
  status: [{ required: true, message: '请选择角色状态', trigger: 'blur' }]
}